import React from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Copyright from '../Copyright';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    [theme.breakpoints.up(500 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(23),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(6),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    color: 'primary',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  titlewrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  logowrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const SignIn = (props) => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="sm">
      <Paper elevation={4} className={classes.paper}>
        <CssBaseline />
        <div className={classes.titlewrapper}>
          <Typography component="h1" variant="h5">
            Charts - Sign in
          </Typography>
        </div>

        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Email Address"
            name="username"
            autoComplete="email"
            autoFocus
            onChange={props.handleChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={props.handleChange}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={props.onSignIn}
          >
            Sign In
          </Button>
        </form>
        <Copyright />
        <br />
        <div className={classes.logowrapper}>
          <img
            src={process.env.PUBLIC_URL + '/DC-Logo-Left-224.png'}
            alt="logo"
          ></img>
        </div>
      </Paper>
    </Container>
  );
};

SignIn.propTypes = {
  handleChange: PropTypes.func.isRequired,
  onSignIn: PropTypes.func.isRequired,
};

export default SignIn;
